module.exports = __webpack_public_path__ + "img/magento-custom-development_small.bd8a8f43.webp";